export default "__VITE_ASSET__CqUayOSa__"